import { IconButton, useTheme } from "@mui/material";
import { Trash2 } from "lucide-react";
import type { FC } from "react";

type Props = {
	onClick: () => void;
};

export const RemoveItemButton: FC<Props> = ({ onClick }) => {
	const theme = useTheme();

	return (
		<IconButton variant="ghost" color="error" onClick={onClick}>
			<Trash2 size={theme.iconSize.sm} color={theme.palette.red[400]} />
		</IconButton>
	);
};
